// Appointment
export const SET_APPOINTMENT = 'SET_APPOINTMENT';
export const RESET_APPT = 'RESET_APPT';
export const SET_TEAM_IDS = 'SET_TEAM_IDS';
export const SET_START_TIME = 'SET_START_TIME';
export const SET_END_TIME = 'SET_END_TIME';
export const CLEAR_START_TIME = 'CLEAR_START_TIME';
export const SET_RESERVATION_ID = 'SET_RESERVATION_ID';
export const SET_TRANSPORTATION_OPTION = 'SET_TRANSPORTATION_OPTION';
export const SET_ATTENDANCE_STATUS = 'SET_ATTENDANCE_STATUS';
export const SET_CONFIRMATION_KEY = 'SET_CONFIRMATION_KEY';
export const SET_CALL_BACK = 'SET_CALL_BACK';
export const SET_APPT_LEAD = 'SET_APPT_LEAD';
export const SET_LIFECYCLE_STATE = 'SET_LIFECYCLE_STATE';
export const SET_TRANSPORTATION_LABEL = 'SET_TRANSPORTATION_LABEL';
export const SET_CARRY_OVER = 'SET_CARRY_OVER';
export const SET_DMS_APPT = 'SET_DMS_APPT';
export const SET_IS_QUOTE_APPT = 'SET_IS_QUOTE_APPT';

// Comments
export const SET_PARTICIPANT_COMMENTS = 'SET_PARTICIPANT_COMMENTS';

// CustomerVehicle
export const SET_VEHICLE = 'SET_VEHICLE';
export const SET_MAKE = 'SET_MAKE';
export const SET_YEAR = 'SET_YEAR';
export const SET_MODEL = 'SET_MODEL';
export const SET_TRIM = 'SET_TRIM';
export const SET_TRANSMISSION = 'SET_TRANSMISSION';
export const SET_ENGINE_TYPE = 'SET_ENGINE_TYPE';
export const SET_DRIVE_TYPE = 'SET_DRIVE_TYPE';
export const SET_ENGINE_SIZE = 'SET_ENGINE_SIZE';
export const SET_MILEAGE = 'SET_MILEAGE';
export const SET_REG_DATE = 'SET_REG_DATE';
export const SET_LICENSE_NUMBER = 'SET_LICENSE_NUMBER';
export const SET_META_VEHICLE_ID = 'SET_META_VEHICLE_ID';
export const SET_CUSTOMER_VEHICLE = 'SET_CUSTOMER_VEHICLE';

// Services
export const SET_SERVICES = 'SET_SERVICES';
export const ADD_SERVICE = 'ADD_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const UPDATE_TELLUSMORE_SERVICE = 'UPDATE_TELLUSMORE_SERVICE';
export const UPDATE_SERVICE_COMMENT = 'UPDATE_SERVICE_COMMENT';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const CLEAR_APPT_SERVICES = 'CLEAR_APPT_SERVICES';
export const ADD_DECLINED_SERVICE = 'ADD_DECLINED_SERVICE';
export const SET_AUTORECALL_SERVICES = 'SET_AUTORECALL_SERVICES';
export const SET_APPT_DECLINED_SERVICES = 'SET_APPT_DECLINED_SERVICES';
export const REMOVE_DECLINED_SERVICE = 'REMOVE_DECLINED_SERVICE';
export const CLEAR_DECLINED_SERVICES = 'CLEAR_DECLINED_SERVICES';

// Packages
export const SET_APPT_SERVICE_POINT = 'SET_APPT_SERVICE_POINT';
export const UPDATE_APPT_SERVICE_POINT = 'UPDATE_APPT_SERVICE_POINT';
export const REMOVE_PACKAGE_SERVICE = 'REMOVE_PACKAGE_SERVICE';

// Advisor
export const SET_ADVISOR = 'SET_ADVISOR';
export const SET_ADVISOR_NAME = 'SET_ADVISOR_NAME';
export const CLEAR_SELECTED_ADVISOR = 'CLEAR_SELECTED_ADVISOR';

// Available Times
export const CLEAR_AVAILABLE_TIMES = 'CLEAR_AVAILABLE_TIMES';

// Appointment Options
export const CLEAR_APPT_OPTIONS = 'CLEAR_APPT_OPTIONS';
export const SET_TRANSP_OPTION_INFO = 'SET_TRANSP_OPTION_INFO';
export const CLEAR_APPOINTMENT_SELECTED_DAY = 'CLEAR_APPOINTMENT_SELECTED_DAY';

// Privacy Settings
export const SET_PRIVACY_SETTINGS = 'SET_PRIVACY_SETTINGS';
export const SET_RESERVATION_STATUS_PRIVACY_SETTINGS =
  'SET_RESERVATION_STATUS_PRIVACY_SETTINGS';



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/actionTypes.js